import type { TFunction } from "i18next";
import { u3125FormatCurrency } from "../../../../../u3125Facture/U3125";
import { u3125FormatWipTransactionKindLabel } from "../../../../../u3125Facture/U3125Service";
import { NS } from "../../../../U3121";
import type { U3121BillingProjectProfitabilityByKind } from "../../../../U3121Service";

interface U3121BillingSummaryProfitabilityKindBreakdownProps {
  byKind: U3121BillingProjectProfitabilityByKind[];
  t: TFunction;
}

function U3121BillingSummaryProfitabilityKindBreakdown({ byKind, t }: U3121BillingSummaryProfitabilityKindBreakdownProps) {
  if (!byKind.length) return null;

  return (
    <div className="mt-3 border-t border-gray-100 pt-3">
      <p className="mb-2 text-xs font-medium text-muted-foreground">{t("lblProfitabilityByKind", { ns: NS })}</p>
      <table className="w-full text-xs">
        <thead>
          <tr className="text-left text-muted-foreground">
            <th className="pb-1 font-medium">{t("colBillingSummaryKind", { ns: NS })}</th>
            <th className="pb-1 text-right font-medium">{t("lblLineCount", { ns: NS })}</th>
            <th className="pb-1 text-right font-medium">{t("lblTotalAmount", { ns: NS })}</th>
            <th className="pb-1 text-right font-medium">{t("lblTotalCostAmount", { ns: NS })}</th>
          </tr>
        </thead>
        <tbody>
          {byKind.map((row, idx) => (
            <tr key={`${row.transactionKind}-${idx}`} className="border-t border-gray-100">
              <td className="py-1">{u3125FormatWipTransactionKindLabel(row.transactionKind, t, NS)}</td>
              <td className="py-1 text-right tabular-nums">{row.lineCount}</td>
              <td className="py-1 text-right tabular-nums">{u3125FormatCurrency(row.totalSellingAmount)}</td>
              <td className="py-1 text-right tabular-nums">{u3125FormatCurrency(row.totalCostAmount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default U3121BillingSummaryProfitabilityKindBreakdown;
